module.exports = __webpack_public_path__ + "img/spotify-icon.2c01bc0.svg";